import Svg, { Defs, G, Path } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: style */

const Omni = () => {
  return (
    <Svg width={64} height={64} viewBox="0 0 64 64">
      <Defs />
      <Path d="M32 0A32 32 0 110 32 32 32 0 0132 0z" fill="#0070b6" />
      <Path
        d="M32.817 38.983a6.168 6.168 0 116.168 6.168 6.166 6.166 0 01-6.168-6.168zm-13.125 5.379v-10.67h10.666v10.67zm4.668-14l7.332-12 7.332 12z"
        fill="#24397a"
      />
      <Path d="M15.694 15.694h32v32h-32z" />
      <G>
        <Path
          d="M32.817 38.983a6.168 6.168 0 116.168 6.168 6.166 6.166 0 01-6.168-6.168zm-13.125 5.379v-10.67h10.666v10.67zm4.668-14l7.332-12 7.332 12z"
          fill="#fff"
        />
        <Path d="M15.694 15.694h32v32h-32z" />
      </G>
    </Svg>
  )
}

export { Omni }
